import Cookies from 'js-cookie';

module.exports =
    {
        "/": {
            templateUrl: TFL_Core_Template_Location + 'home.html?v=' + new Date().toLocaleString(),
            controller: 'homeController'
        },
        "/geo_blocked/": {
            templateUrl: TFL_Core_Template_Location + 'geo-block.html?v=' + new Date().toLocaleString(),
            controller: 'homeController'
        },
        "/auth": {
            template: '',
            controller: 'authController'
        },
        "/connect": {
            template: '',
            controller: 'connectController'
        },
        "/howtoplay": {
            templateUrl: TFL_Core_Template_Location + 'how-to-play.html?v=' + new Date().toLocaleString(),
            controller: 'homeController'
        },
        "/about": {
            templateUrl: TFL_Core_Template_Location + 'about.html?v=' + new Date().toLocaleString(),
            controller: 'homeController'
        },
        "/adding-to-cart": {
            templateUrl: TFL_Core_Template_Location + 'adding-to-cart.html?v=' + new Date().toLocaleString(),
            controller: 'homeController'
        },
        "/faq": {
            templateUrl: TFL_Core_Template_Location + 'faq.html?v=' + new Date().toLocaleString(),
            controller: 'FAQController'
        },
        "/geofence": {
            templateUrl: TFL_Core_Template_Location + 'geofence.html?v=' + new Date().toLocaleString(),
            controller: 'homeController'
        },
        "/excluded": {
            templateUrl: TFL_Core_Template_Location + 'excluded.html?v=' + new Date().toLocaleString(),
            controller: 'homeController'
        },
        "/closed": {
            templateUrl: TFL_Core_Template_Location + 'closed.html?v=' + new Date().toLocaleString(),
            controller: 'closedController'
        },
        "/settings": {
            templateUrl: 'settings.html?v=' + new Date().toLocaleString(),
            controller: 'settingsController',
            controllerAs: 'ctrl',
            resolve: {
                User: function ($http, $q) {
                    'ngInject';
                    var deferred = $q.defer()

                    $http.get(TFL_Base_Url + 'auth?ApiKey=' + Cookies.get('TLF_Auth_Token'))
                        .then(function (response) {
                            deferred.resolve(response.data);
                        });

                    return deferred.promise
                }
            }
        },
        "/order-history": {
            templateUrl: 'order-history.html?v=' + new Date().toLocaleString(),
            controller: 'homeController'
        },
        "/checkout": {
            templateUrl: TFL_Core_Template_Location + 'checkout.html?v=' + new Date().toLocaleString(),
            controller: 'payController'
        },
        "/error": {
            templateUrl: TFL_Core_Template_Location + 'error.html?v=' + new Date().toLocaleString(),
            controller: 'homeController'
        },
        "/prelaunch": {
            templateUrl: TFL_Core_Template_Location + 'prelaunch.html?v=' + new Date().toLocaleString(),
            controller: 'homeController'
        },
        "/error-paypal": {
            templateUrl: TFL_Core_Template_Location + 'error-paypal.html?v=' + new Date().toLocaleString(),
            controller: 'homeController'
        },
        "/draws": {
            templateUrl: TFL_Core_Template_Location + 'draws.html?v=' + new Date().toLocaleString(),
            controller: 'homeController'
        },
        "/purchase": {
            templateUrl: TFL_Core_Template_Location + 'purchase.html?v=' + new Date().toLocaleString(),
            controller: 'purchaseController'
        },
        "/renew-tickets": {
            templateUrl: TFL_Core_Template_Location + 'purchase.html?v=' + new Date().toLocaleString(),
            controller: 'purchaseController'
        },
        "/purchase/:TicketNumber/:FriendlyTicketNumber": {
            templateUrl: TFL_Core_Template_Location + 'purchase.html?v=' + new Date().toLocaleString(),
            controller: 'purchaseController'
        },
        "/select-card": {
            templateUrl: TFL_Core_Template_Location + 'select-card.html?v=' + new Date().toLocaleString(),
            controller: 'purchaseController'
        },
        "/adding-new-to-cart/:PlanId/:Quantity": {
            templateUrl: TFL_Core_Template_Location + 'adding-to-cart.html?v=' + new Date().toLocaleString(),
            controller: 'AddToCartController'
        },
        "/adding-cta-cart/:PlanId/:Quantity/:CardId": {
            templateUrl: TFL_Core_Template_Location + 'adding-to-cart.html?v=' + new Date().toLocaleString(),
            controller: 'AddCTACartController'
        },
        "/adding-existing-to-cart/:PlanId": {
            templateUrl: TFL_Core_Template_Location + 'adding-to-cart.html?v=' + new Date().toLocaleString(),
            controller: 'AddToCartController'
        },
        "/tickets": {
            templateUrl: TFL_Core_Template_Location + 'tickets.html?v=' + new Date().toLocaleString(),
            controller: 'buynewController'
        },
        "/contact": {
            templateUrl: TFL_Core_Template_Location + 'contact.html?v=' + new Date().toLocaleString(),
            controller: 'homeController'
        },
        "/responsible-gaming": {
            templateUrl: TFL_Core_Template_Location + 'responsible-gaming.html?v=' + new Date().toLocaleString(),
            controller: 'homeController'
        },
        "/unsubscribed": {
            templateUrl: TFL_Core_Template_Location + 'unsubscribed.html?v=' + new Date().toLocaleString(),
            controller: 'homeController'
        },
        "/thank-you/:CartTransactionId": {
            templateUrl: TFL_Core_Template_Location + 'thank-you.html?v=' + new Date().toLocaleString(),
            controller: 'receiptController'
        },

        "/winners": {
            templateUrl: TFL_Core_Template_Location + 'winners.html?v=' + new Date().toLocaleString(),
            controller: 'homeController'
        },

        "/admin": {
            templateUrl: TFL_Core_Template_Location + 'admin.html?v=' + new Date().toLocaleString(),
            controller: 'AdminCTRL'
        },
        "/admin-reports": {
            templateUrl: TFL_Core_Template_Location + 'admin-reports.html?v=' + new Date().toLocaleString(),
            controller: 'AdminReportsCTRL'
        },
        "/confirm-email": {
            templateUrl: TFL_Core_Template_Location + 'home.html?v=' + new Date().toLocaleString(),
            controller: 'confirmemailCTRL'
        },
        "/password-reset": {
            templateUrl: TFL_Core_Template_Location + 'home.html?v=' + new Date().toLocaleString(),
            controller: 'homeController'
        },
        "/facebook-profile-notfound": {
            templateUrl: TFL_Core_Template_Location + 'home.html?v=' + new Date().toLocaleString(),
            controller: 'homeController'
        },
        "/google-profile-notfound": {
            templateUrl: TFL_Core_Template_Location + 'home.html?v=' + new Date().toLocaleString(),
            controller: 'homeController'
        },
        "/finalize-account/:MemberId": {
            templateUrl: TFL_Core_Template_Location + 'home.html?v=' + new Date().toLocaleString(),
            controller: 'finalizeaccountCTRL'
        },
        "/unsubscribe": {
            templateUrl: TFL_Core_Template_Location + 'home.html?v=' + new Date().toLocaleString(),
            controller: 'homeController'
        },
        "/geofence-facebook": {
            templateUrl: TFL_Core_Template_Location + 'geofence-facebook.html?v=' + new Date().toLocaleString(),
            controller: 'homeController'
        },
        "/geofence-email": {
            templateUrl: TFL_Core_Template_Location + 'geofence-email.html?v=' + new Date().toLocaleString(),
            controller: 'homeController'
        },
        "/terms-and-conditions": {
            templateUrl: TFL_Core_Template_Location + 'terms-and-conditions.html?v=' + new Date().toLocaleString(),
            controller: 'homeController'
        },
        "/privacy-policy": {
            templateUrl: TFL_Core_Template_Location + 'privacy-policy.html?v=' + new Date().toLocaleString(),
            controller: 'homeController'
        },
        "/under-construction": {
            templateUrl: TFL_Core_Template_Location + 'under-construction.html?v=' + new Date().toLocaleString(),
            controller: 'homeController'
        },
        "/service-interruption": {
            templateUrl: TFL_Core_Template_Location + 'service-interruption.html?v=' + new Date().toLocaleString(),
            controller: 'homeController'
        }
    };